import { post } from "@/api/http";

export default {
    // 創建遊戲活動
    createGameActivity: function (data) {
        return post("/gameactivity/create-gameactivity", data);
    },

    // 獲取我的遊戲活動列表（支援搜尋與分頁）
    getMyGameActivities: function (data) {
        return post("/gameactivity/get-my-gameactivities", data);
    },

    // 更新遊戲活動
    updateGameActivity: function (data) {
        return post("/gameactivity/update-gameactivity", data);
    },

    // 獲取單一遊戲活動（公開）
    getGameActivity: function (data) {
        return post("/gameactivity/get-gameactivity", data);
    },

    // 刪除遊戲活動
    deleteGameActivity: function (data) {
        return post("/gameactivity/delete-gameactivity", data);
    },

    // 提交遊戲成績（不需登入）
    submitScore: function (data) {
        return post("/gameactivity/submit-score", data);
    },

    // 查詢活動成績列表（需登入）
    getActivityScores: function (data) {
        return post("/gameactivity/get-activity-scores", data);
    },

    // 檢查活動數量限制（需登入）
    checkActivityLimit: function (data) {
        return post("/gameactivity/check-activity-limit", data);
    }
}
